<template v-if="loaded">
  <f7-page>
    <navbar :text="`${$t('Configuration.name')} > ${$t('Configuration.Observations_Title')}`" />
    <PopupConfirmObservationExit />
    <HeaderTemplateForm
      :templates-categories="templatesCategories"
      :template-category="currentObservationTemplate.category"
      :form-name="currentObservationTemplate.subcategory"
    />
    <AttributesTemplateForm
      :attributes="currentObservationTemplate.form"
    />
    <f7-row>
      <f7-col>
        <f7-button
          class="dx-btn-cancel btnBack margin-left"
          raised
          type="default"
          text-color="grey"
          styling-mode="outlined"
          @click="goToObservations"
        >
          {{ $t("Go_Back") }}
        </f7-button>
      </f7-col>
      <f7-col>
        <f7-button
          class="dx-btn-success"
          raised
          styling-mode="outlined"
          name="ButtonSave"
          @click="callEditObservationTemplate"
        >
          {{ $t('Button_save_text') }}
        </f7-button>
      </f7-col>
    </f7-row>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import navbar from '../../../components/NavBar.vue';
import HeaderTemplateForm from '../../../components/configuration/observations/headerTemplateForm/index.vue';
import AttributesTemplateForm from '../../../components/configuration/observations/attributesTemplateForm/index.vue';
import PopupConfirmObservationExit from '../../../components/searcher/observations/popupConfirmObservationExit/index.vue';

export default {
  name: 'EditObservationTemplate',
  components: {
    navbar,
    HeaderTemplateForm,
    AttributesTemplateForm,
    PopupConfirmObservationExit,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState('Observations', ['currentObservationTemplate', 'templatesCategories', 'currentObservationTemplateId']),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      await this.fetchTemplatesCategories();
      await this.getTemplateById(this.currentObservationTemplateId);
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(`${error}`),
          width: 550,
        },
        'error',
        3000,
      );
    } finally {
      this.$f7.preloader.hide();
    }
  },
  methods: {
    async callEditObservationTemplate() {
      if (this.currentObservationTemplate.category === '') {
        this.$notifyDX(
          {
            message: this.$t('Configuration.Category_Validation'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.currentObservationTemplate.subcategory === '') {
        this.$notifyDX(
          {
            message: this.$t('Configuration.Subcategory_Validation'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.currentObservationTemplate.form.length === 0) {
        this.$notifyDX(
          {
            message: this.$t('Configuration.Form_Validation'),
            width: 550,
          },
          'info',
          3000,
        );
      } else {
        this.$f7.preloader.show();
        try {
          await this.updateObservationTemplate({ observationTemplateId: this.currentObservationTemplateId, observationTemplate: this.currentObservationTemplate });
        } catch (error) {
          this.$notifyDX(
            {
              message: this.$t(`${error}`),
              width: 550,
            },
            'error',
            3000,
          );
        } finally {
          this.$f7.preloader.hide();
          this.$f7.views.main.router.navigate('/observations/', { reloadCurrent: true });
        }
      }
    },
    goToObservations() {
      this.$f7.views.main.router.navigate('/observations/', { reloadCurrent: true });
    },
    ...mapActions('Observations', ['updateObservationTemplate', 'fetchTemplatesCategories', 'getTemplateById']),
  },
};
</script>
